import {useCallback, useEffect, useState} from 'react';

export function useIsDarkMode() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  const getIsDarkMode = useCallback(() => {
    return document.body.classList.contains('dark');
  }, []);

  useEffect(() => {
    setIsDarkMode(getIsDarkMode());
    const observer = new MutationObserver(() => {
      setIsDarkMode(getIsDarkMode());
    });
    observer.observe(document.body, {
      attributes: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [getIsDarkMode]);

  return isDarkMode;
}
